import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import "./navbar-spacing.css";

const C = {
  bg: "#0a0a0f", surface: "rgba(255,255,255,0.04)", sh: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)", text: "#f5f5f7",
  sec: "rgba(245,245,247,0.55)", ter: "rgba(245,245,247,0.30)",
  orange: "#ff9f0a", purple: "#bf5af2",
};
const F = "-apple-system,'SF Pro Display','Helvetica Neue',sans-serif";

const ITEMS = [
  { label: "Banner pubblicitari", sub: "Banner nel menu del locale", path: "/gestione-banner", color: C.orange },
  { label: "Sponsor popup",       sub: "Popup pubblicitari a schermo", path: "/gestione-sponsor", color: C.purple },
];

export default function Sponsor() {
  return (
    <>
      <Navbar />
      <div style={{ minHeight:"100vh", background:C.bg, fontFamily:F, color:C.text }}>
        <div className="page-with-navbar" style={{ maxWidth:700, margin:"0 auto" }}>

          <div style={{ marginBottom:"2rem" }}>
            <p style={{ margin:"0 0 0.25rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Amministrazione</p>
            <h1 style={{ margin:0, fontSize:"clamp(1.4rem,3vw,1.9rem)", fontWeight:700, letterSpacing:"-0.5px" }}>Gestione Pubblicità</h1>
            <p style={{ margin:"0.3rem 0 0", fontSize:"0.82rem", color:C.ter }}>Scegli il tipo di pubblicità da gestire</p>
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:"1rem" }}>
            {ITEMS.map((item, i) => (
              <Link key={i} to={item.path} style={{ textDecoration:"none" }}>
                <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:"1.5rem 1.25rem", display:"flex", flexDirection:"column", gap:"0.6rem", transition:"all 200ms ease", cursor:"pointer" }}
                  onMouseEnter={e => { e.currentTarget.style.background = C.sh; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.borderColor = item.color + "44"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = C.surface; e.currentTarget.style.transform = ""; e.currentTarget.style.borderColor = C.border; }}
                >
                  <span style={{ width:36, height:36, borderRadius:10, background:item.color+"18", display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <span style={{ width:14, height:14, borderRadius:4, background:item.color, display:"block" }} />
                  </span>
                  <div>
                    <p style={{ margin:"0 0 0.2rem", fontSize:"0.95rem", fontWeight:700, color:C.text }}>{item.label}</p>
                    <p style={{ margin:0, fontSize:"0.78rem", color:C.sec }}>{item.sub}</p>
                  </div>
                  <span style={{ fontSize:"0.72rem", color:item.color, fontWeight:600, marginTop:"0.25rem" }}>Gestisci →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
